<template>
    <div class="row">
       <div class="mx-auto col-md-12">               
            <div class="card p-3 mb-3">
                <div class="card-body">
                    <beneficiarioHeader 
                        :cpf_requerente="familia.cpf_requerente"
                        :nome_completo="familia.nome_completo"
                        :situacao="familia.ind_ativo">
                    </beneficiarioHeader>                    
                    <b-card
                        class="mb-2"
                        header="Conta Bancária"
                        header-tag="header">
                        <b-form inline>
                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="nome_completo">Banco</label>
                                <b-form-input
                                    id="banco"
                                    type="text"
                                    v-model="familia.codigo_banco"
                                    disabled
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-1`"
                                ></b-form-input>
                                <label class="mr-sm-1 p-0" for="nome_banco"></label>
                                <b-form-input
                                    id="nome_banco"
                                    type="text"
                                    v-model="familia.nome_banco"
                                    disabled
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-5`"
                                ></b-form-input>
                            </div>
                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="agencia">Agência</label>
                                <the-mask
                                    id="conta"
                                    pattern="[0-9\.\-]*"
                                    inputmode="numeric"
                                    v-model="familia.agencia"
                                    mask="#####"
                                    placeholder="Agência"
                                    :masked="false"
                                    type="text"
                                    @change.native="alteraDados"
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-2 form-control`"
                                    :disabled="!$store.getters.userRoles.includes($constantes.usuario.ROLES.SUPERADMINISTRADOR)"
                                ></the-mask>
                                <label class="ml-2 mr-2 p-0" for="dv_agencia"> - </label>
                                <the-mask
                                    id="dv_conta"
                                    inputmode="text"
                                    v-model="familia.dv_agencia"
                                    mask="#"
                                    :masked="false"
                                    type="text"
                                    @change.native="alteraDados"
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-1 form-control`"
                                    :disabled="!$store.getters.userRoles.includes($constantes.usuario.ROLES.SUPERADMINISTRADOR)"
                                ></the-mask>
                            </div>
                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="conta">Conta</label>
                                <the-mask
                                    id="conta"
                                    pattern="[0-9\.\-]*"
                                    inputmode="numeric"
                                    v-model="familia.numero_conta"
                                    mask="############"
                                    placeholder="Conta"
                                    :masked="false"
                                    type="text"
                                    @change.native="alteraDados"
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-2 form-control`"
                                    :disabled="!$store.getters.userRoles.includes($constantes.usuario.ROLES.SUPERADMINISTRADOR)"
                                ></the-mask>
                                <label  class="ml-2 mr-2 p-0" for="dv_conta"> - </label>
                                <b-form-input
                                    id="dv_conta"
                                    maxlength="1"
                                    v-model="familia.dv_conta"
                                    type="text"
                                    @change.native="alteraDados"
                                    style="text-transform: uppercase"
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-1 form-control`"
                                    :disabled="!$store.getters.userRoles.includes($constantes.usuario.ROLES.SUPERADMINISTRADOR)"
                                ></b-form-input>
                            </div>
                        </b-form>
                        <template v-slot:footer >                                  
                            <b-row >  
                                <b-col class="text-left">   
                                    <b-button                                               
                                        variant="outline-secondary"                   
                                        @click.prevent="voltar" 
                                        title="Voltar">
                                            <font-awesome-icon                                                                      
                                                :icon="['fas','arrow-left']"
                                                title="Voltar"
                                                class="mr-1"
                                            />
                                            Voltar
                                    </b-button>
                                </b-col>
                                <b-col class="text-right" >                    
                                    <b-button                                               
                                        variant="success"              
                                        @click.prevent="salvar"
                                        v-if="$store.getters.userRoles.includes($constantes.usuario.ROLES.SUPERADMINISTRADOR)"
                                        title="Salvar">
                                            <font-awesome-icon                                                                      
                                                :icon="['fas','save']"
                                                title="Salvar"
                                                class="mr-1"
                                            />
                                            Salvar
                                    </b-button>                                
                                </b-col>                         
                            </b-row>
                        </template>                                            
                    </b-card>           
                </div>
            </div>            
       </div>
    </div>
</template>

<script>

import { TheMask } from "vue-the-mask";
import Familia from '../../../models/Familia'
import beneficiarioHeader from "../../../components/BeneficiarioHeader"

export default {

    components: {
        beneficiarioHeader, 
         TheMask,       
    },
    
    data(){
        return { 
            formAlterado: false,
            familia: new Familia(),                 
        }
    },

    computed: {
    },

    methods: {

        alteraDados(){
            this.formAlterado = true;
        },
        
        salvar(){
            this.$api.put(`familias/${this.familia.id}/atualizar-conta`, this.familia)
                .then(response => {                    
                    if(response){                                      
                        this.formAlterado = false; 
                        this.$helpers.showToast(this, 'Sucesso', response.data.message, 'success');                                        
                    } 
                })
                .catch(error => {                               
                    if(error.response.data){                        
                        this.$helpers.showToast(this, 'Erro', error.response.data.message,' danger');                        
                    } 
                });  
        }, 
        
        voltar(){
            if(this.formAlterado){
               this.$helpers.confirmaVoltar(this)
                    .then(confirmado => { 
                        if(confirmado){                        
                            this.$router.push({ name: 'beneficiarios'}); 
                        } 
                    });
            } else {
                this.$router.push({ name: 'beneficiarios'}); 
            }
        },

        async load() {
            try {
                const id = this.$route.params.id;
                const result = await this.$api.get(`familias/${id}`);  
                this.familia = new Familia(result.data.familia);
                this.familia.codigo_banco = 104;
                this.familia.nome_banco = "CAIXA ECONÔMICA FEDERAL";
            }catch(error) {
                if(error.response.data){                        
                    this.$helpers.showToast(this,'Erro', error.response.data.message, 'danger');
                }
            }  
        }

    },

    mounted() {
        this.load();
    }
}

</script>

<style scoped>
</style>
